<div class="inbuilt-report-wrapper p-relative" >
    <div class="inbuilt-loader-container" *ngIf="isPageChanging">
        <div class="loader"><app-loader></app-loader></div>
    </div>
    <div class="main-div-with-gray-bkg inbuilt-report-container pt-3"  *ngIf="showView">
        <div class="row" *ngIf="reportNameFromInput == ''">
            <div class="col-12">
                <div class="breadcrumb-div d-flex align-items-center justify-content-end">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item cursor-pointer"><a [routerLink]="['/landing-page']">Home</a></li>
                            <li class="breadcrumb-item cursor-pointer" [routerLink]="['/reports']" aria-current="page">
                                Reports</li>
                            <li class="breadcrumb-item active" aria-current="page">{{reportNameFromQueryParams | titlecase}}
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
        <!-- remove below section-->
        <!-- <ng-container *ngIf="initialDataLoaded && false">
            <div class="row main-block p-relative">
                <div class="col-12">
                    
                </div>
                <div class="col-12">
                    <mat-tab-group (selectedTabChange)="reportTabChange($event)" aria-label="Reports Tabs" role="tablist"
                        [ngClass]="{'hide-tab': isTabLabelEmpty}">
                        <mat-tab *ngFor="let tab of tabs" [label]="tab.name" role="tab">
                            <ng-container *ngIf="selectedTab.value === tab.value">
                                <ng-container *ngIf="allFilters && allFilters.length > 0">
                                    <app-inbuilt-filters [showView]="showView" [allFilters]="allFilters" (setTableValues)="setTableValues($event,tab.value)"
                                        (updateFieldList)="updateFieldList($event)"
                                        [cascadeData]="cascadeData"></app-inbuilt-filters>
                                </ng-container>
                            </ng-container>
                        </mat-tab>
                    </mat-tab-group>
                </div>
    
                <div class="documentation-icon">
                    <button [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Documentation'"
                        class="uitk-icon uitk-icon-info_hollow md-icon no-border me-2  cursor-pointer" title="Info"
                        (click)="info()">
                    </button>
                </div>
    
            </div>
            <div class="row  mt-4">
                <div class="col-12 main-block" *ngIf="showTable && !showLoader">
                    <app-inbuilt-table [columns]="columns" [reportNameFromQueryParams]="reportNameFromQueryParams"
                        [tableData]="filteredTableData"  [currentDate]="currentDate"
                        [currentTime]="currentTime" (refreshTable)="refreshTableData($event)"></app-inbuilt-table>
                </div>
                <ng-container *ngIf="tableLoader">
                    <div class="d-flex justify-content-center align-items-center ">
                        <app-loader></app-loader>
                    </div>
                </ng-container>
            </div>
        </ng-container> -->
        <!-- remove above section-->
         <ng-container *ngIf="isChildReportDataLoaded && currentPage && currentTab">
            <div class="row main-block ps-0 pages-row" *ngIf="pages?.length > 1" >
                <div class="col-12 d-flex align-items-center justify-content-between" *ngIf="sideNavTheme !== 'theme2'">
                    <app-inbuilt-pages-v2  [pages]="pages" [currentSelectedPage]="currentPage" (pageChange)="onPageChange($event)"></app-inbuilt-pages-v2>

                    <div class="documentation-icon documentation-icon-inline" *ngIf="isTabLabelEmpty">
                        <div class="json-editor-toggle-row" *ngIf="hasPageAccessRole">
                            <span class="json-editor-toggle-label">Enable Editing</span>
                            <mat-slide-toggle [checked]="showJsonEditor" (change)="onJsonEditorToggleChange($event.checked)">
                            </mat-slide-toggle>
                        </div>
                        <button [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Documentation'"
                            class="uitk-icon uitk-icon-info_hollow md-icon no-border me-2 cursor-pointer" title="Info"
                            (click)="info()">
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- Theme / Side-nav toolbar -->
            <!-- <div class="row main-block side-nav-toolbar-row" *ngIf="shouldShowSideNav()">
                <div class="col-12 d-flex align-items-center justify-content-end">
                    <div class="theme-toggle-group" role="group" aria-label="View mode">
                        <button type="button" class="theme-btn" [class.active]="sideNavTheme === 'theme1'" (click)="setSideNavTheme('theme1')">Theme 1</button>
                        <button type="button" class="theme-btn" [class.active]="sideNavTheme === 'theme2'" (click)="setSideNavTheme('theme2')">Theme 2</button>
                    </div>
                </div>
            </div> -->

            <div class="row main-block p-relative" [ngClass]="{'main-block-theme2': sideNavTheme === 'theme2' && shouldShowSideNav()}">
                <!-- Side navigation panel (Theme 2 only) -->
                <div class="side-nav-col"
                     *ngIf="sideNavTheme === 'theme2' && shouldShowSideNav()"
                     [ngClass]="{'side-nav-expanded': sideMenuExpanded, 'side-nav-collapsed': !sideMenuExpanded}">
                    <app-sidemenu
                        [nodes]="sideMenuNodes"
                        [isCollapsed]="!sideMenuExpanded"
                        [showToggle]="true"
                        [selectedNodeId]="currentTab ? (currentPage?.key + '__' + currentTab?.key) : null"
                        [isEditMode]="hasPageAccessRole && showJsonEditor"
                        (toggleCollapse)="toggleSideMenu()"
                        (nodeSelect)="onSideMenuNodeSelect($event)"
                        (saveStructure)="onSideMenuSave($event)">
                    </app-sidemenu>
                </div>

                <div [ngClass]="getContentColClass()">
                    <div class="row" *ngIf="selectedNodeUnavailable">
                        <div class="col-12 text-center no-element-message py-5">
                            This visual is not available.
                        </div>
                    </div>
                    <mat-tab-group *ngIf="!selectedNodeUnavailable" (selectedTabChange)="onTabChange($event)" aria-label="Reports Tabs" role="tablist"
                        [selectedIndex]="getSelectedTabIndex()"
                        [ngClass]="{'hide-tab': isTabLabelEmpty || sideNavTheme === 'theme2'}">
                        <mat-tab *ngFor="let tab of currentPage?.tabs" [label]="tab.name" role="tab">
                            <ng-container *ngIf="currentTab.key === tab.key">
                                <div class="row" *ngIf="!isPageChanging && noElementsForTab">
                                    <!-- <div class="col-12 text-center no-element-message py-5">
                                        There are no report element added to display currently. Add Visuals to report.
                                        
                                    </div> -->
                                    <div class="col-12">
                                    <app-inbuilt-custom-report #inbuiltCustomReport [dataSourceJson]="dataSourceJson" [reportId]="parentJSON ? parentJSON.id : null" [hasReportAdminRole]="hasReportAdminRole" [currentVisualCount]="currentTabVisualCount" [reportNameFromQueryParams]="reportNameFromQueryParams" (filterCreateRequested)="onCustomFilterCreate($event)" (visualCreateRequested)="onCustomVisualCreate($event)"
                                        (filterSavedAndClosed)="onCustomFilterSavedAndClosed()"></app-inbuilt-custom-report>

                                    </div>
                                </div>
                                <div class="row widget-elements-row" *ngIf="!isPageChanging && !noElementsForTab">
                                    <div #widgetHost class="report-widget-slot" *ngFor="let el of tab.elements; let elementIndex = index; trackBy: trackByElement" [ngClass]="[getElementLayoutClass(el, tab), shouldAddRowStartPadding(el, tab, elementIndex, tab.elements) ? 'ps-2' : '']">
                                        <ng-container [ngSwitch]="el.type">
                                            <div *ngSwitchCase="'filter'">
                                                <app-inbuilt-filters-v2 [config]="pageConfig" [dataSourceJson]="dataSourceJson" [showView]="showView" [elementData]="el" (onFiltersApplied)="handleTableAttribute($event)"></app-inbuilt-filters-v2>
                                            </div>
                                            <ng-container *ngIf="searchTriggered ">
                                                <div *ngSwitchCase="'table'">
                                                <app-inbuilt-table-v2 [config]="tableConfig" [elementData]="el"></app-inbuilt-table-v2>
                                            </div>
                                            <div *ngSwitchCase="'metrics'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)" [elementData]="el" [config]="tableConfig" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-matrix [config]="tableConfig" [elementData]="el"></app-inbuilt-matrix>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'drill_down_matrix'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)" [elementData]="el" [config]="tableConfig" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-drill-down-matrix [config]="tableConfig" [elementData]="el"></app-inbuilt-drill-down-matrix>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'parent_child_table'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)" [elementData]="el" [config]="tableConfig" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-parent-child-table [config]="tableConfig" [elementData]="el"></app-parent-child-table>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'column_chart'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="el.resolvedHeading || getElementWrapperTitle(el)" [elementData]="el" [config]="tableConfig" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-column-chart-v2 [config]="tableConfig" [elementData]="el" (headingResolved)="el.resolvedHeading = $event"></app-column-chart-v2>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'bar_chart'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="el.resolvedHeading || getElementWrapperTitle(el)" [elementData]="el" [config]="tableConfig" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-bar-chart-v2 [config]="tableConfig" [elementData]="el" (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-bar-chart-v2>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'parent_group'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="el.resolvedHeading || getElementWrapperTitle(el)" [elementData]="el" [config]="tableConfig" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-header-v2 [config]="tableConfig" [elementData]="el" (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-header-v2>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'card'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="el.resolvedHeading || getElementWrapperTitle(el)" [elementData]="el" [config]="tableConfig" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-card-v2 [config]="tableConfig" [elementData]="el" (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-card-v2>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'speedometer'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)" [elementData]="el" [config]="tableConfig" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-speedometer-v2 [config]="tableConfig" [elementData]="el"></app-inbuilt-speedometer-v2>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'stat_card'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="el.resolvedHeading || getElementWrapperTitle(el)" [elementData]="el" [config]="tableConfig" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-stat-card [config]="tableConfig" [elementData]="el" (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-stat-card>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'stack_chart'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="el.resolvedHeading || getElementWrapperTitle(el)" [elementData]="el" [config]="tableConfig" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-stack-chart [config]="tableConfig" [elementData]="el" (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-stack-chart>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <!-- <div *ngSwitchCase="'speedometer_v2'"> -->
                                                <!-- <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)"> -->
                                                <!-- </app-inbuilt-visual-wrapper-v2> -->
                                            <!-- </div> -->
                                            
                                            </ng-container>
                                            <!-- add other element types here -->
                                        </ng-container>

                                    </div>
                                </div>
                                <div class="row">
                                    <!-- <div class="col-4">
                                                    <app-inbuilt-speedometer-v2 [config]="tableConfig" [elementData]="el"></app-inbuilt-speedometer-v2>

                                    </div> -->
                                    <!-- <div class="col-12">
                                                    <app-inbuilt-stat-card [config]="tableConfig" [elementData]="el"></app-inbuilt-stat-card>

                                    </div> -->
                                </div>
                            </ng-container>
                        </mat-tab>
                    </mat-tab-group>
                </div>
                <div class="documentation-icon" >
                    <div class="json-editor-toggle-row" *ngIf="hasPageAccessRole">
                        <!-- <button *ngIf="showJsonEditor" type="button" class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base me-2 cursor-pointer" (click)="openJSONeditorForParent()">Edit Report JSON</button> -->
                        <div class="report-type-btn-group" *ngIf="showJsonEditor" #addVisualMenuContainer>
                            <button type="button" class="add-visual-type-btn" (click)="toggleAddVisualTypeMenu()">
                                <mat-icon aria-hidden="true">add</mat-icon>
                                <span>Add visual</span>
                            </button>

                            <div class="add-visual-type-menu" *ngIf="showAddVisualTypeMenu">
                                <button type="button" class="add-visual-type-menu-item" *ngFor="let option of visualTypeOptions"
                                    (click)="onSelectVisualType(option)">
                                    <mat-icon class="add-visual-type-menu-icon" aria-hidden="true">{{ option.icon }}</mat-icon>
                                    <span class="add-visual-type-menu-text">
                                        <span class="add-visual-type-menu-label">{{ option.label }}</span>
                                        <span class="add-visual-type-menu-description">{{ option.description }}</span>
                                    </span>
                                </button>
                            </div>
                            <div class="report-type-menu report-type-icon-menu" *ngIf="showMenu">
                                <div class="report-type-segment" *ngIf="filterMenuItems.length > 0">
                                    <div class="report-type-segment-label">Filter</div>
                                    <div class="report-type-icon-row">
                                        <button type="button" class="report-type-icon-btn" *ngFor="let item of filterMenuItems; trackBy: trackByVisualMenuItem"
                                            [class.disabled]="item.alreadyDefined" [disabled]="item.alreadyDefined"
                                            [title]="item.tooltip" (click)="openAddVisualJsonModal(item.type)">
                                            <mat-icon>{{ item.icon }}</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="report-type-segment" *ngIf="visualMenuItems.length > 0">
                                    <div class="report-type-segment-label">Visuals</div>
                                    <div class="report-type-icon-row">
                                        <button type="button" class="report-type-icon-btn" *ngFor="let item of visualMenuItems; trackBy: trackByVisualMenuItem"
                                            [class.disabled]="item.alreadyDefined" [disabled]="item.alreadyDefined"
                                            [title]="item.tooltip" (click)="openAddVisualJsonModal(item.type)">
                                            <mat-icon>{{ item.icon }}</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <button *ngIf="showJsonEditor" type="button" class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base me-2 cursor-pointer" (click)="deleteReport()">Delete Report</button> -->
                        
                        <span class="json-editor-toggle-label">Enable Editing</span>
                        <mat-slide-toggle [checked]="showJsonEditor" (change)="onJsonEditorToggleChange($event.checked)">
                        </mat-slide-toggle>

                    </div>
                    <button [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Documentation'"
                        class="uitk-icon uitk-icon-info_hollow md-icon no-border me-2  cursor-pointer" title="Info" (click)="info()">
                    </button>
                </div>
                
    
            </div>
        </ng-container>
    
    </div>

</div>
<div class="inbuilt-loader-container" *ngIf="!showView">
    <div class="loader"><app-loader></app-loader></div>
    <div class="loader-text">
        <p>Please wait while we load the report</p>
    </div>
</div>
<app-modal [maximizable]="true" [inViewport]="true" #modalEditJSON class="modal-demo  edit-json-popup"
    (closeModal)="hidepopup('edit')">
    <ng-container class="app-modal-header">Visual Editor</ng-container>
    <ng-container class="app-modal-body">
        <ng-container *ngIf="isJSONeditorPopupOpen">
            <app-json-editor [initialJson]="parentJSON?.parent_json || {}" [jsonType]="'parent'"
                (jsonTextChange)="onJsonEditorTextChange($event)">
            </app-json-editor>
        </ng-container>
    </ng-container>
</app-modal>

<app-modal [maximizable]="true" [inViewport]="true" #modalAddVisualJSON class="modal-demo edit-json-popup"
    (closeModal)="hidepopup('add-visual')">
    <ng-container class="app-modal-header">Visual Editor — {{ selectedVisualType | titlecase }}</ng-container>
    <ng-container class="app-modal-body">
        <ng-container *ngIf="isAddVisualJsonPopupOpen">
            <app-inbuilt-editor
                [menuItems]="addVisualMenuItems"
                [initialJson]="addVisualJsonData"
                [queryCode]="''"
                [jsonType]="selectedVisualType === 'filter' ? 'filter' : 'other'"
                [disableSave]="!isAddVisualFormValid"
                (jsonTextChange)="onAddVisualJsonTextChange($event)">
                <div editor-fields-row class="add-visual-template-fields-row mb-3">
                    <div class="add-visual-field">
                        <label class="section-name">Element Name <span class="asterik">*</span></label>
                        <input type="text" class="add-visual-input" [(ngModel)]="addVisualElementName" placeholder="Enter element name">
                        <div *ngIf="duplicateElementExist" class="duplicate-element-warning" (ngModelChange)="onDuplicateElementExistChange($event)">
                            A visual element with this name and type already exists.
                        </div>
                    </div>
                    <div class="add-visual-field">
                        <label class="section-name">Rank <span class="asterik">*</span></label>
                        <input type="number" class="add-visual-input" [(ngModel)]="addVisualElementRank"
                            (ngModelChange)="onAddVisualRankChange()" [disabled]="isAddVisualRankDisabled" min="1"
                            placeholder="Enter rank/order">
                    </div>
                    <div class="add-visual-field">
                        <label class="section-name">Width <span class="asterik">*</span></label>
                        <input #addVisualWidthInputEl type="number" class="add-visual-input" [(ngModel)]="addVisualElementWidth"
                            (ngModelChange)="onAddVisualWidthChange(addVisualWidthInputEl)" min="1" max="12" placeholder="Enter width (1-12)">
                    </div>
                </div>
            </app-inbuilt-editor>
        </ng-container>
    </ng-container>
</app-modal>

<app-modal [maximizable]="true" [inViewport]="true" #addVisualTypeModal class="modal-demo add-visual-type-popup"
    (closeModal)="onAddVisualTypeCancelled()">
    <ng-container class="app-modal-header">
        <div class="add-visual-type-popup__heading">
            <span class="add-visual-type-popup__title">{{ addVisualTypeModalBody.modalTitle }}</span>
            <span class="add-visual-type-popup__subtitle">Describe the visual you need and generate a ready-to-review configuration.</span>
        </div>
    </ng-container>
    <ng-container class="app-modal-body">
        <app-add-visual-modal #addVisualTypeModalBody [visualTypeLabel]="selectedVisualTypeOption?.label || ''"
            [reportId]="parentJSON?.id" [selectedDataSource]="dataSourceJson" [filterElementJson]="currentTabFilterJson"
            [currentVisualCount]="currentTabVisualCount" [hasReportAdminRole]="hasReportAdminRole"
            (cancelled)="onAddVisualTypeCancelled()" (visualCreated)="onVisualTypeCreated($event)" [selectedElementType]="selectedVisualTypeOption?.type || ''">
        </app-add-visual-modal>
    </ng-container>
    <ng-container class="app-modal-footer">
        <div class="add-visual-type-popup__footer">
            <div class="add-visual-type-popup__actions" *ngIf="addVisualTypeModalBody.selectedMenuId !== 'sql-query'">
                <button type="button" class="add-visual-type-popup__btn add-visual-type-popup__btn--secondary"
                    (click)="addVisualTypeModalBody.onCancel()">
                    Cancel
                </button>
                <button *ngIf="addVisualTypeModalBody.selectedMenuId === 'visual-editor' || addVisualTypeModalBody.selectedMenuId === 'json-editor'"
                    type="button" class="add-visual-type-popup__btn add-visual-type-popup__btn--secondary"
                    [disabled]="!addVisualTypeModalBody.canValidate" (click)="addVisualTypeModalBody.onValidate()">
                    Validate
                </button>
                <button *ngIf="addVisualTypeModalBody.showPrimaryAction" type="button" class="add-visual-type-popup__btn add-visual-type-popup__btn--primary"
                    [disabled]="!addVisualTypeModalBody.canPerformPrimaryAction" (click)="addVisualTypeModalBody.onPrimaryAction()">
                    {{ addVisualTypeModalBody.primaryActionLabel }}
                </button>
            </div>
        </div>
    </ng-container>
</app-modal>
